module.exports = __webpack_public_path__ + "static/media/dr_fiedler_martin.2158f236.jpg";